'use strict';

var $ = require('core-utils/modules/jquery-extend'),
    JqueryDebounce  = require('core-utils/modules/jquery-debounce'),
    gtxConstants = require('./gtx-constants');

var parsley = require('parsleyjs/dist/parsley.js');
var lang = gtxConstants('DEFAULT_LANG');

require('parsleyjs/dist/i18n/' + lang + '.js')

parsley.setLocale(gtxConstants('DEFAULT_LANG'));

JqueryDebounce.init( {timing: 100, type: 'rAF', fncAsap: false, namespace: 'getrix-common'} );

module.exports = $;
